import React from 'react'
import styled from '@emotion/styled/macro'

export const Banner = styled('div')`
    padding: 0.5rem;
    border-radius: var(--borderRadius-sm);
`

export const InfoBanner = styled(Banner)`
    background: var(--colors-primary-accent);
`

export const DangerBanner = styled(Banner)`
    background: var(--colors-warning);
`
